// extracted by mini-css-extract-plugin
export var Card = "CardSwitch-module--Card--02dbf";
export var active = "CardSwitch-module--active--b2405";
export var bottomContent = "CardSwitch-module--bottomContent--7585f";
export var capitalize = "CardSwitch-module--capitalize--a324a";
export var cardsContainer = "CardSwitch-module--cardsContainer--5d4bf";
export var fs14 = "CardSwitch-module--fs-14--25d97";
export var fs16 = "CardSwitch-module--fs-16--e7de1";
export var fs20 = "CardSwitch-module--fs-20--b1e21";
export var fs24 = "CardSwitch-module--fs-24--d8278";
export var fs32 = "CardSwitch-module--fs-32--0d190";
export var fs40 = "CardSwitch-module--fs-40--51c20";
export var fsItalic = "CardSwitch-module--fs-italic--d6c40";
export var fsLg = "CardSwitch-module--fs-lg--396ce";
export var fsMd = "CardSwitch-module--fs-md--e73bb";
export var fsNormal = "CardSwitch-module--fs-normal--de6f8";
export var fsSm = "CardSwitch-module--fs-sm--91547";
export var fsXl = "CardSwitch-module--fs-xl--2fba1";
export var fsXs = "CardSwitch-module--fs-xs--6a539";
export var fsXxl = "CardSwitch-module--fs-xxl--d7ef2";
export var fsXxs = "CardSwitch-module--fs-xxs--fdbf5";
export var fwBold = "CardSwitch-module--fw-bold--9ec1c";
export var fwMedium = "CardSwitch-module--fw-medium--467a2";
export var fwNormal = "CardSwitch-module--fw-normal--517d3";
export var gotham_bold = "CardSwitch-module--gotham_bold--c57ff";
export var gotham_bold_italic = "CardSwitch-module--gotham_bold_italic--88690";
export var gotham_book = "CardSwitch-module--gotham_book--41201";
export var gotham_book_italic = "CardSwitch-module--gotham_book_italic--2789b";
export var img = "CardSwitch-module--img--06046";
export var jobHeader = "CardSwitch-module--jobHeader--7a1b4";
export var lienUnstyled = "CardSwitch-module--lienUnstyled--afde1";
export var lowercase = "CardSwitch-module--lowercase--bc03b";
export var overlay = "CardSwitch-module--overlay--64abe";
export var sectionStyle = "CardSwitch-module--sectionStyle--4594e";
export var showOverlay = "CardSwitch-module--showOverlay--c8ca6";
export var tabButton = "CardSwitch-module--tabButton--52203";
export var tabButtons = "CardSwitch-module--tabButtons--ed912";
export var tabbtnBg = "CardSwitch-module--tabbtnBg--f7140";
export var uppercase = "CardSwitch-module--uppercase--50e82";